import { Avatar, Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconLogout } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../auth/authStore';
import { logout } from '../../auth/authApi';

export function UserMenu() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const tenantSlug = useAuthStore((s) => s.tenantSlug);
  const clear = useAuthStore((s) => s.clear);

  if (!user) return null;

  const displayName = i18n.language === 'ar' ? user.fullNameAr : (user.fullNameEn ?? user.fullNameAr);
  const initials = displayName
    .split(' ')
    .slice(0, 2)
    .map((part) => part[0] ?? '')
    .join('')
    .toUpperCase();

  const handleLogout = async () => {
    await logout(tenantSlug).catch(() => {
      /* idempotent — server returns 204 either way */
    });
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <Menu position="bottom-end" withinPortal width={220}>
      <Menu.Target>
        <UnstyledButton className="rounded-md px-2 py-1 hover:bg-gray-100">
          <Group gap="sm" wrap="nowrap">
            <Avatar size={32} radius="xl" color="wheels">
              {initials || 'U'}
            </Avatar>
            <div className="hidden text-start leading-tight sm:block">
              <Text fz="sm" fw={500} c="var(--wheels-ink)" lh={1.2}>
                {displayName}
              </Text>
              <Text fz="xs" c="var(--wheels-ink-muted)" lh={1.2}>
                {user.roles[0] ?? user.tenantSlug}
              </Text>
            </div>
            <IconChevronDown size={14} stroke={1.8} className="text-gray-400" />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{displayName}</Menu.Label>
        <Menu.Item
          leftSection={<IconLogout size={16} stroke={1.6} />}
          onClick={() => void handleLogout()}
        >
          {t('common.logout')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
